const APIURl = process.env.VUE_APP_BASE_API

module.exports = {
	APIURl: APIURl,
	timeout: process.env.NODE_ENV === 'development' ? 1000000 : 1000000,
	WebSocketUrl: process.env.NODE_ENV === 'development' ? APIURl.replace('http', 'ws') + '/api/message/websocket' : process.env.VUE_APP_BASE_WSS,
	comUploadUrl: APIURl + '/api/file/Uploader',
	comUrl: APIURl,
	// 本地文件预览
	filePreviewServer: process.env.NODE_ENV === 'development' ? 'http://192.168.110.77:30003/preview' : 'http://192.168.110.77:30003/preview',
	// 大屏应用前端路径
	dataV: process.env.NODE_ENV === 'development' ? 'http://localhost:20001/DataV' :  'http://192.168.110.77:20001/DataV/',
	// 数据报表接口-java boot
	reportServer: process.env.NODE_ENV !== 'development' ? 'http://localhost:30002' : 'http://192.168.110.77:30002',
	// 数据报表接口-java cloud
	// reportServer: process.env.NODE_ENV === 'development' ? 'http://localhost:30000' : process.env.VUE_APP_BASE_API,
	// 报表前端
	report: process.env.NODE_ENV !== 'development' ? 'http://localhost:20002/html' : 'http://192.168.110.77:20002'
}
